import { putApi } from "./api_instance";

export const orderPayment = async ({transactionId, formData, dispatch}) => {
  try {
    return await putApi({
      apiUrl: `/payments/api/wallet/pay-through-wallet?transaction_id=${transactionId}`,
      dispatch,
      sendToken: true,
      data: formData, 
    });
  } catch (error) {
    throw error;
  }
};
